'use client';
import { useContext, memo } from 'react';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import VideoThumbnail from '@repo/ui/src/components/VideoThumbnail';
import PlaylistContext from './_PlaylistContext';

const TraegerTVListItem = ({ item }) => {
  const { id, title, thumbnailUrl, description, youtubeLink } = item || {};
  const { push } = useModal(ModalID.video);

  const playlistItems = useContext(PlaylistContext);

  const getYoutubeId = (contentUrl) => contentUrl.split('https://www.youtube.com/watch?v=').pop();

  return (
    <div className="tw-h-full tw-p-4">
      <div>
        <VideoThumbnail
          title={title}
          imgUrl={thumbnailUrl}
          duration={youtubeLink?.duration}
          onClick={() =>
            push({
              youtubeLink: {
                ...youtubeLink,
                youtubeId: getYoutubeId(youtubeLink.contentUrl),
                description: youtubeLink.description ? youtubeLink.description : description,
              },
              playlistItems: playlistItems
                ?.filter((x) => x.id !== id)
                ?.map((x) => ({
                  ...x,
                  youtubeLink: {
                    ...x.youtubeLink,
                    youtubeId: getYoutubeId(x.youtubeLink.contentUrl),
                    description: x.youtubeLink?.description
                      ? x.youtubeLink?.description
                      : x.description,
                  },
                })),
            })
          }
        />
        {title && (
          <h6 className="tw-text-left tw-text-white tw-my-4 tra-text-web-heading-7">{title}</h6>
        )}
      </div>
      {description && <p className="tw-text-white">{description}</p>}
    </div>
  );
};

export default memo(TraegerTVListItem);
